import { EnumHelperBase, type EnumDataObject } from '../../../constants/enum.helpers';

/**
 * ReservationSeat type enumeration
 * @enum {number}
 * @export
 */
export enum RESERVATION_SEAT_TYPE {
	CIRCLE_50CM = 1,
	SEMICIRCLE_50CM = 2,
	RECTANGLE_50CM = 3,
}

/**
 * ReservationSeatType enumeration class
 * @export
 */
export class ReservationSeatTypeEnum extends EnumHelperBase<
	ReservationSeatTypeExtraData,
	RESERVATION_SEAT_TYPE,
	'reservationSeatType',
	'reservationSeatTypeId'
> {
	constructor() {
		super(
			'reservationSeatType',
			/**
			 * List of supported seat_type values
			 * @see https://github.com/NFCtron/nfctron-db/blob/dev/diagrams/reservation.png
			 */
			{
				[RESERVATION_SEAT_TYPE.CIRCLE_50CM]: {},
				[RESERVATION_SEAT_TYPE.SEMICIRCLE_50CM]: {},
				[RESERVATION_SEAT_TYPE.RECTANGLE_50CM]: {},
			},
			'reservationSeatTypeId',
			null,
		);
	}
}

/**
 * ReservationSeatType data type
 * @export
 */
export interface ReservationSeatTypeData extends EnumDataObject<ReservationSeatTypeExtraData, RESERVATION_SEAT_TYPE, 'reservationSeatTypeId'> {}

/**
 * ReservationSeatType extra data type
 * @private
 */
type ReservationSeatTypeExtraData = {};

/**
 * ReservationSeatType enumeration singleton instance export
 * @export
 */
export const reservationSeatTypeEnum = new ReservationSeatTypeEnum();
